import { render, staticRenderFns } from "./EditSoftwareDistribution.vue?vue&type=template&id=dd53c8e2&"
import script from "./EditSoftwareDistribution.vue?vue&type=script&lang=js&"
export * from "./EditSoftwareDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports